import StandardLayout from "./StandardLayout";

export { StandardLayout };
